import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "sizeOptions", [{
      label: 'Default',
      value: 'default'
    }, {
      label: 'Medium',
      value: 'medium'
    }, {
      label: 'Small',
      value: 'small'
    }, {
      label: 'Mini',
      value: 'mini'
    }]);
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "size",
    get: function get() {
      return AppModule.size;
    }
  }, {
    key: "handleSetSize",
    value: function handleSetSize(size) {
      this.$ELEMENT.size = size;
      AppModule.SetSize(size);
      this.refreshView();
      this.$message({
        message: 'Switch Size Success',
        type: 'success'
      });
    }
  }, {
    key: "refreshView",
    value: function refreshView() {
      var _this2 = this;
      // In order to make the cached page re-rendered
      TagsViewModule.delAllCachedViews();
      var fullPath = this.$route.fullPath;
      this.$nextTick(function () {
        _this2.$router.replace({
          path: '/redirect' + fullPath
        });
      });
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  name: 'SizeSelect'
})], default_1);
export default default_1;